import { Icon, type IconName } from '@pco/atoms/Icon';
import { useTheme } from 'styled-components';
import type { Status } from '../index.types';

interface StatusIconProps {
	status: Status;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ status }) => {
	const theme = useTheme();

	const colorMap: Record<'pending' | 'success' | 'error' | 'default', string> =
		{
			pending: theme.semanticTokens.colors.content.primary,
			success: theme.semanticTokens.colors.content.primary,
			error: theme.semanticTokens.colors.content.primaryInverse,
			default: theme.semanticTokens.colors.content.primary,
		};

	const iconMap: Record<'pending' | 'success' | 'error' | 'default', string> = {
		pending: 'animatedDots',
		success: 'checkmark',
		error: 'add',
		default: 'add',
	};

	const statusKey = status ?? 'default';

	const color = colorMap[statusKey];
	const fallbackIcon = iconMap[statusKey] as IconName;

	return (
		<Icon
			fallbackIcon={fallbackIcon}
			color={color}
			width={status === 'pending' ? '30px' : undefined}
		/>
	);
};
